import { render, staticRenderFns } from "./EstablishmentViewPurchasesOrders.vue?vue&type=template&id=50021c00"
import script from "./EstablishmentViewPurchasesOrders.vue?vue&type=script&lang=js"
export * from "./EstablishmentViewPurchasesOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports